import { Link, Text } from '@nimbus-ds/components';
import { InvoiceItemInterface } from '@tiendanube/common';
import useDownloadInvoice from 'domains/Billing/Invoices/pages/InvoicesListPage/components/InvoiceHistory/useDownloadInvoice';

type InvoiceItemProps = InvoiceItemInterface;

function InvoiceItem({
  item,
  type,
  isCreditNote,
  associatedInvoiceId,
  isFromBillingEngine,
}: InvoiceItemProps): JSX.Element {
  const shouldLetDownloadCancelledInvoice =
    isFromBillingEngine &&
    isCreditNote &&
    associatedInvoiceId &&
    type.includes('#');

  const { getLinkForBillingEngine } = useDownloadInvoice();

  const typeText = shouldLetDownloadCancelledInvoice ? (
    <Text as="span">
      {` - ${type.split('#')[0]}`}
      <Link
        as="span"
        appearance="primary"
        onClick={() => getLinkForBillingEngine(associatedInvoiceId)}
      >{`#${type.split('#')[1]}`}</Link>
    </Text>
  ) : (
    <Text as="span">{` - ${type}`}</Text>
  );
  return (
    <>
      <Text as="span" fontWeight="bold">
        {item}
      </Text>
      {typeText}
    </>
  );
}

export default InvoiceItem;
